(function($){

  function getAdHolders() {
    return $('.advertisement-holder').map(function(){
      return $(this);
    });
  }

  var intvl = 1E3;
  var defaultHeight = 50;
  var adHolders = getAdHolders();

  setInterval(function() {
    adHolders.each(function(){
      var adHeight = this.height();
      var thresholdHeight = this.data('label-height') || defaultHeight;
      this.toggleClass('ad-visible', adHeight >= thresholdHeight);
      return;
    });
  }, intvl);

  return window.MW && window.MW.events.subscribe('infinite_scroll', function(){
    adHolders = getAdHolders();
  });

})(window.jQuery);
